import { renderRoute } from './mapbox';

const mapBlocks = document.querySelectorAll('.mapblock');

mapBlocks.forEach((mapBlock) => {
    const canvas = mapBlock.querySelector('.map-canvas');
    const map = renderRoute(canvas);
});